import React from 'react';
import FilterTable from './FilterTable';
import DataTablePerforma from './DataTablePerforma';
import { FilterPerformaPoskoProps } from '../../container/PerformaPosko';

type PerformaPoskoComponentsProps = {
  dataAllBranch: Array<any>;
  dataCustomers: Array<any>;
  dataProducts: Array<any>;
  isLoadingBranch?: boolean;
  isLoadingCustomers?: boolean;
  isLoadingProducts?: boolean;
  IdBranch?: number;
  roleAccount: string;
  initialValue: any;
  handleResetFilter: () => void;
  handleDownload: () => void;
  handleChangeFilter: (name: string, value: any) => void;
  handleSubmitFilter: (value: FilterPerformaPoskoProps) => void;
  dataTable: any;
  isLoadingTable: boolean;
};

export default function PerformaPoskoComponents({
  dataCustomers,
  dataProducts,
  isLoadingCustomers,
  isLoadingProducts,
  isLoadingTable,
  dataTable,
  dataAllBranch,
  isLoadingBranch,
  IdBranch,
  roleAccount,
  initialValue,
  handleChangeFilter,
  handleResetFilter,
  handleSubmitFilter,
  handleDownload,
}: PerformaPoskoComponentsProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <FilterTable
        dataAllBranch={dataAllBranch}
        isLoadingBranch={isLoadingBranch}
        selectedBranchId={IdBranch}
        roleAccount={roleAccount}
        initialValue={initialValue}
        handleResetFilter={handleResetFilter}
        handleChangeFilter={handleChangeFilter}
        handleSubmitFilter={handleSubmitFilter}
        dataCustomers={dataCustomers}
        dataProducts={dataProducts}
        isLoadingCustomers={isLoadingCustomers}
        isLoadingProducts={isLoadingProducts}
      />
      <DataTablePerforma
        dataTable={dataTable}
        isLoadingTable={isLoadingTable}
        handleChangeFilter={handleChangeFilter}
        handleDownload={handleDownload}
      />
    </div>
  );
}
